import { render } from "./ClientCart.vue?vue&type=template&id=66bb8053&scoped=true"
import script from "./ClientCart.vue?vue&type=script&lang=js"
export * from "./ClientCart.vue?vue&type=script&lang=js"

import "./ClientCart.vue?vue&type=style&index=0&id=66bb8053&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bb8053"]])

export default __exports__